module.exports = __webpack_public_path__ + "static/media/exclamation-point-black-20x20.bba1bee1.svg";